import BusPriceClass from '@itinerary/trip/bus/BusPriceClass';
import VerifyResult from '@itinerary/VerifyResult';
import PassengerForm from '@itinerary/PassengerForm';
import { PassengerFields } from '@store/form';
import { type InvoiceEntry } from '@store/invoice';
import BusBillHandler from '@itinerary/trip/bus/BusBillHandler';
import { PaxTypeTitles } from '@itinerary/trip/TripModuleTypes';
import { PaxType } from '@utils/types';

export default class BusAutoPriceClass extends BusPriceClass {
    override verify(
        count: { adultCount: number; childCount: number; infantCount: number },
        billId: number | null
    ): Promise<VerifyResult> {
        const realCount = count.adultCount + count.childCount;
        const paxCount = this.totallyExclusive
            ? 1
            : this.isSelectedToBeExclusive
              ? this.capacity
              : realCount; // maybe count send from other trip module
        const defaultFields =
            PassengerFields.PersianFirstName |
            PassengerFields.PersianLastName |
            PassengerFields.NationalCode |
            PassengerFields.BirthDate |
            PassengerFields.Gender;
        const prices: InvoiceEntry[] = [];
        const totalPrice = 0;
        if (this.totallyExclusive) {
            prices.push({
                paxType: PaxType.Adult,
                count: 1,
                price: totalPrice,
                discount: 0,
                title: 'دربستی',
            });
        } else {
            prices.push({
                paxType: PaxType.Seat,
                count: realCount,
                price: totalPrice / paxCount,
                discount: 0,
                title: '',
            });
            if (this.isSelectedToBeExclusive) {
                prices.push({
                    paxType: PaxType.EmptySeat,
                    count: paxCount - realCount,
                    price: totalPrice / paxCount,
                    discount: 0,
                    title: '',
                });
            }
        }
        const adultForm: PassengerForm = new PassengerForm({
            title: PaxTypeTitles[PaxType.Adult],
            type: PaxType.Adult,
            defaultFields,
            iranianExtraFields: PassengerFields.None,
            foreignerExtraFields: PassengerFields.None,
        });
        return Promise.resolve(
            new VerifyResult(
                new BusBillHandler(0, this.id, this.totallyExclusive),
                {
                    paxList: this.totallyExclusive
                        ? [
                              new PassengerForm({
                                  type: PaxType.Adult,
                                  title: 'سرپرست مسافرین',
                                  defaultFields,
                                  iranianExtraFields: PassengerFields.None,
                                  foreignerExtraFields: PassengerFields.None,
                              }),
                          ]
                        : [
                              ...Array(realCount)
                                  .fill(0)
                                  .map(
                                      () =>
                                          new PassengerForm({
                                              type: PaxType.Adult,
                                              title: PaxTypeTitles[
                                                  PaxType.Adult
                                              ],
                                              defaultFields,
                                              iranianExtraFields:
                                                  PassengerFields.None,
                                              foreignerExtraFields:
                                                  PassengerFields.None,
                                          })
                                  ),
                          ],
                    adultForm,
                    billId: billId || undefined,
                    payablePrice: 0,
                    discount: 0,
                    totalPrice,
                    remainingTime: 600,
                    priceEntries: [
                        {
                            prices,
                        },
                    ],
                    needsDestinationMobile: false,
                    loadDefaultPassenger: true,
                    disablePaxTypeValidation: true,
                }
            )
        );
    }
}
